var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "task-list-view" } }, [
    _vm.isLoading && _vm.tasks.length === 0
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("a-spin", { attrs: { size: "large" } }, [
              _c(
                "span",
                {
                  staticClass: "loading-text",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(_vm._s(_vm.$t("auto.loadingTasks")))]
              ),
            ]),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "kanban-task-table" },
          [
            _c("supsis-table", {
              attrs: {
                columns: _vm.columns,
                rows: _vm.tasks,
                "bottom-pagination": true,
                "pagination-cursor": _vm.paginationCursor,
                options: _vm.tableOptions,
                loading: _vm.isLoading,
              },
              on: { "cursor-changed": _vm.handlePaginationChange },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }